import React from "react";
import styled from "styled-components";

const Aoe2Links = ({ player }) => (
  <Wrapper>
    <LinkItem
      href={`https://aoe2.net/#aoe2de-profile-${player.aoe2ProfileId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <LinkIcon src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/aoe2net.png" alt="" />
      AoE2.net
    </LinkItem>
    <LinkItem
      href={`https://www.aoe2insights.com/user/${player.aoe2ProfileId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <LinkIcon src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/aoe2insights.webp" alt="" />
      aoe2insights
    </LinkItem>
    <LinkItem
      href={`https://aoe2.gg/profile/${player.aoe2ProfileId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <LinkIcon src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/aoe2_gg.svg" alt="" />
      aoe2.gg
    </LinkItem>
    <LinkItem
      href={`https://smurf.new-chapter.eu/check_player?player_id=${player.aoe2ProfileId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <LinkIcon src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/smurf.svg" alt="" />
      smurfdb
    </LinkItem>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  flex-wrap: wrap;
`;

const LinkItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  text-decoration: none;

  &:hover {
    color: var(--v-hover);
  }
`;

const LinkIcon = styled.img`
  width: 1rem;
  height: 1rem;
  object-fit: contain;
`;

export default Aoe2Links;
